import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{ params?: object, query?: object }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Workspace.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   title: string,
 *   code: string,
 *   description?: string | null,
 *   tagGroupIds?: string[]
 * }} form
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Workspace.Create(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Workspace.GetById(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   params: { id: string },
 *   body: {
 *     title: string,
 *     code: string,
 *     description?: string | null,
 *     tagGroupIds?: string[],
 *     isActive?: boolean
 *   }
 * }} option
 */
export const Update = async (option) => {
  const response = await $api.put(
    Endpoints.Workspace.Update({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Workspace.Delete(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
